(function () {
  //console.log('Page loaded Yes! ' + window.location.href);  
  if((window.location.href == 'https://richesjewelry.com/collections/womens') ||
     (window.location.href == 'https://richesjewelry.com/collections/mens') || 
    (window.location.href == 'https://richesjewelry.com/collections/kids-jewelry') || 
    (window.location.href == 'https://richesjewelry.com/collections/diamonds-collection') || 
    (window.location.href == 'https://richesjewelry.com/collections/wedding')){
    document.getElementById('shopify-section-template--16792521113840__promo-grid').style.display = 'block';
  }


   /* Language Drop down top of nav */
	if(window.location.href.indexOf('/pt') > 0){
		document.querySelector('.language-selected').src = 'https://cdn.shopify.com/s/files/1/0605/0067/2752/files/icon-pt-lang.png?v=1711136795';
	}else if (window.location.href.indexOf('/es') > 0){		
		document.querySelector('.language-selected').src = 'https://cdn.shopify.com/s/files/1/0605/0067/2752/files/icon-spanish-lang.png?v=1711376875';
	}else{
		document.querySelector('.language-selected').src = 'https://cdn.shopify.com/s/files/1/0605/0067/2752/files/icon-usa-lang.png?v=1711136795';		
	}
	
	document.querySelector('.language-selected').onmouseover = function() {		
		if(document.querySelector('.dropdown-menu').style.display == 'none') { 
			document.querySelector('.dropdown-menu').style.display = 'inline-block';
		}
		else {
			document.querySelector('.dropdown-menu').style.display = 'none';
		}
	}
	
	document.querySelector('.language-toggle').onmouseover = function() {		
		if(document.querySelector('.dropdown-menu').style.display == 'none') { 
			document.querySelector('.dropdown-menu').style.display = 'inline-block';
		}
		else {
			document.querySelector('.dropdown-menu').style.display = 'none';
		}
	}

    /*document.querySelector('.language-toggle').onmouseout = function() {	
      document.querySelector('.dropdown-menu').style.display = 'none';
    }*/
	
	var langOpt = document.getElementsByClassName('language-opt');	
	for(let x = 0; x < langOpt.length; x++){
		langOpt[x].onclick = function() {			
			var langLinkRel = langOpt[x].attributes['rel'].value;
			var langLinkURL = document.getElementById(langLinkRel);
			window.location.href = langLinkURL; 			
			//console.log(langLinkRel + ' ' + langLinkURL);
		}
	}
 
})();
